import React, { useState } from 'react';
import { useVMContext } from '../context/VMContext';

const VMStatusBar = () => {
  const { session, secondsLeft, resumeSession } = useVMContext();
  const [expanded, setExpanded] = useState(false);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  };

  if (!session) return null;

  const isUrgent = secondsLeft < 300;

  return (
    <div
      style={{ position: 'fixed', bottom: '80px', right: '24px', zIndex: 9998 }}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      {expanded ? (
        <div className={`rounded-xl shadow-2xl p-4 flex flex-col gap-3 min-w-[200px] ${
          isUrgent
            ? 'bg-red-900 border border-red-500'
            : 'bg-emerald-900 border border-emerald-500'
        }`}>
          <div className="flex items-center gap-2">
            <span className="relative flex h-2.5 w-2.5 flex-shrink-0">
              <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
                isUrgent ? 'bg-red-400' : 'bg-green-300'
              }`}></span>
              <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${
                isUrgent ? 'bg-red-300' : 'bg-green-200'
              }`}></span>
            </span>
            <span className="text-white text-xs font-semibold truncate max-w-[150px]">
              {session.vm_id}
            </span>
          </div>
          <div className={`text-center text-sm font-bold font-mono rounded-lg py-1 ${
            isUrgent
              ? 'bg-red-500/50 text-red-200 animate-pulse'
              : 'bg-emerald-500/30 text-yellow-300'
          }`}>
            ⏱ {formatTime(secondsLeft)} idle
          </div>
          <button
            onClick={resumeSession}
            className="w-full py-1.5 bg-white/20 hover:bg-white/30 text-white text-xs font-bold rounded-lg transition-colors"
          >
            ▶ Resume Terminal
          </button>
        </div>
      ) : (
        <div className={`rounded-full shadow-xl px-3 py-2 flex items-center gap-2 cursor-pointer transition-all ${
          isUrgent
            ? 'bg-red-600 animate-pulse'
            : 'bg-emerald-700'
        }`}>
          <span className="relative flex h-2 w-2 flex-shrink-0">
            <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
              isUrgent ? 'bg-red-300' : 'bg-green-300'
            }`}></span>
            <span className={`relative inline-flex rounded-full h-2 w-2 ${
              isUrgent ? 'bg-red-200' : 'bg-green-200'
            }`}></span>
          </span>
          <span className="text-white text-xs font-bold font-mono">
            {formatTime(secondsLeft)}
          </span>
        </div>
      )}
    </div>
  );
};

export default VMStatusBar;
